import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import layout from './layout';
import students from './students';
// eslint-disable-next-line import/no-cycle
import auth from './auth';
import attendances from './attendances';
import homeworks from './homeworks';
import grades from './grades';
import lessons from './lessons';
import uploadedHomeworks from './uploaded-homeworks';
import materials from './materials';
import onboarding from './onboarding';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    layout,
    auth,
    students,
    attendances,
    homeworks,
    grades,
    lessons,
    uploadedHomeworks,
    materials,
    onboarding,
  },
  plugins: [createPersistedState({
    key: 'earlystage-state',
    paths: [
      'auth', 'students', 'attendances', 'homeworks', 'grades', 'lessons', 'materials',
    ],
  })],
});
